<template>
  <div>
    <v-row class="justify-center ma-4">
      <v-btn text outlined color="primary" @click="dialog = !dialog">Tutorial WeTransfer</v-btn>
    </v-row>
    <v-dialog
      v-model="dialog"
      persistent
      :overlay="false"
      max-width="400px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          Tutorial
          <v-spacer></v-spacer>
          <v-btn icon color="accent" @click="dialog=!dialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="justify-center">
            <v-img
              max-height="300"
              max-width="200"
              :src="image"
            ></v-img>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn icon color="primary" @click="imgMinus()"><v-icon>mdi-arrow-left</v-icon></v-btn>
          <v-spacer></v-spacer>
          <span>{{ texto }}</span>
          <v-spacer></v-spacer>
          <v-btn icon color="primary" @click="imgPlus()"><v-icon>mdi-arrow-right</v-icon></v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import img1 from "../assets/tutorial01.png";
import img2 from "../assets/tutorial02.png";
import img3 from "../assets/tutorial03.png";
import img4 from "../assets/tutorial04.png";

export default {
  name: "we-transfer",
  data() {
    return {
      dialog: false,
      images: [img1, img2, img3, img4],
      textos: ["No site do WeTransfer clique no ícone de 3 pontinhos para mais opções.", "Escolha Criar link", "Faça o upload das imagens, preencha os dados e clique em Pegar link.", "Copie o link gerado e nos envie por email."],
      image: img1,
      texto: "No site do WeTransfer clique no ícone de 3 pontinhos para mais opções.",
      i: 0,
    };
  },
  methods: {
    imgPlus() {
      this.i += 1
      if (this.i >= 3) {
        this.i = 3
      }
      this.image = this.images[this.i]
      this.texto = this.textos[this.i]
    },
    imgMinus() {
      this.i -= 1
      if (this.i <= 0) {
        this.i = 0
      }
      this.image = this.images[this.i]
      this.texto = this.textos[this.i]
    }
  },
};
</script>
